export default __webpack_public_path__ + "static/media/logo.0e5518e9.png";